module.exports = __webpack_public_path__ + "img/image17.875316e4.png";